import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class StateLookupBase {

//#region countryId Prop
        @gridColumn({visible: true, columnIndex:0, allowSorting: true, headerKey: 'countryId', keyColumn: true})
        countryId : number;
//#endregion countryId Prop


//#region stateId Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'stateId', keyColumn: false})
        stateId : number;
//#endregion stateId Prop


//#region stateName Prop
        @gridColumn({visible: true, columnIndex:2, allowSorting: true, headerKey: 'stateName', keyColumn: false})
        stateName : string;
//#endregion stateName Prop

}